const emptyComplianceState = {
  taskDomains: [],
  taskDomainsLoading: false,
  flagSubmitting: false,
  createSubmitting: false,
  createdObligations: [],
}

export default emptyComplianceState
